import { initializeApp } from "firebase/app";
import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  getFirestore,
  setDoc,
} from "firebase/firestore";
import { IArticle } from "./blog-api";

const firebaseConfig = {
  apiKey: "AIzaSyAi0g0alwQwktlA5Sz58LK2L-O6XMtGr4g",
  authDomain: "yettey-app.firebaseapp.com",
  databaseURL: "https://yettey-app.firebaseio.com",
  projectId: "yettey-app",
  storageBucket: "yettey-app.appspot.com",
  messagingSenderId: "745930857771",
  appId: "1:745930857771:web:afc4e0b48f548ac799f96e",
  measurementId: "G-YT4VYBYMMC",
};

initializeApp(firebaseConfig);
const db = getFirestore();

export async function addArticle(art: IArticle, isDraft?: boolean) {
  const { id, ...article } = art;
  try {
    const citiesRef = collection(db, "articles");
    console.log({ ...article, isDraft: isDraft });
    if (id) {
      await setDoc(doc(citiesRef), { ...article, isDraft: isDraft });
      console.log("Document written with ID: ", id);
    } else {
      const docRef = await addDoc(citiesRef, { ...article, isDraft: isDraft });
      console.log("Document written with ID: ", docRef.id);
    }
  } catch (e) {
    console.error("Error adding document: ", e);
  }
}

export async function getArticles() {
  const data: IArticle[] = [];
  try {
    const querySnapshot = await getDocs(collection(db, "articles"));
    querySnapshot.forEach((doc) => {
      data.push({ ...doc.data(), id: doc.id } as IArticle);
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getArticleWithID(id: string) {
  try {
    const docRef = doc(db, "articles", id);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return docSnap.data() as IArticle;
    } else {
      console.log("No such document!");
    }
  } catch (error) {
    console.error(error);
  }
}
